import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cfa20b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-container" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-md-3 card-brand" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "row mb-4" }
const _hoisted_6 = { class: "col-md-3 card-brand" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardMonthTotals = _resolveComponent("DashboardMonthTotals")!
  const _component_DashboardRealizedBudget = _resolveComponent("DashboardRealizedBudget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DashboardMonthTotals, {
          salesChannelName: _ctx.selectedchannel.fullname.toUpperCase(),
          monthTotals: _ctx.setFunction('monthTotals'),
          loading: _ctx.setFunction('loadingMonthTotals'),
          access: _ctx.setFunction('access')
        }, null, 8, ["salesChannelName", "monthTotals", "loading", "access"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DashboardRealizedBudget, {
            realizedBudget: _ctx.setFunction('realizedBudget'),
            channelName: _ctx.selectedchannel.fullname.toUpperCase(),
            loading: _ctx.setFunction('loadingRealizedBudget'),
            access: _ctx.setFunction('access')
          }, null, 8, ["realizedBudget", "channelName", "loading", "access"])
        ])
      ])
    ])
  ]))
}